<template>
  <FormContainer withoutDivider>
    <template #title>Contrat</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_100"
          :model-value="typeContratAvenantModel"
          label="Type de contrat ou d’avenant"
          :required="meta.contrat?.typeContratAvenant?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.typeContratAvenant?.$messageErreurDirty!"
          class="col-36"
          :items="lov.TypeContratAvenant"
          key-id="code"
          key-label="intitule"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_101"
          v-model="modeContractuelModel"
          :items="lov.ModeContractuel"
          key-id="code"
          key-label="intitule"
          label="Mode contractuel de l’apprentissage"
          :required="meta.contrat?.modeContractuel?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.modeContractuel?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :readonly
        />
        <WrapperDropdown
          id="field_103"
          v-model="typeDerogationModel"
          label="Type de dérogation"
          :items="lov.TypeDerogation"
          key-id="code"
          key-label="intitule"
          :required="meta.contrat?.typeDerogation?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.typeDerogation?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_102"
          v-model="numeroContratPrecedentModel"
          label="Numéro du contrat précédent ou du contrat sur lequel porte l’avenant (DECA)"
          :required="meta.contrat?.numeroDecaPrecedent?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.numeroDecaPrecedent?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          :maxlength="15"
          deletable
          :readonly
          :disabled="meta.contrat?.numeroDecaPrecedent?.$status === PropertyStatus.NotPresent"
        />
        <WrapperInputDate
          id="field_107"
          v-model="dateEffetAvenantModel"
          label="Si avenant, date d’effet"
          :required="meta.contrat?.dateEffetAvenant?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateEffetAvenant?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-18 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
          :disabled="meta.contrat?.dateEffetAvenant?.$status === PropertyStatus.NotPresent"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_104"
          v-model="dateConclusionModel"
          label="Date de conclusion (signature du présent contrat)"
          :required="meta.contrat?.dateConclusion?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateConclusion?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_105"
          v-model="dateDebutExecutionModel"
          label="Date de début d’exécution du contrat"
          :required="meta.contrat?.dateDebutExecutionContrat?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateDebutExecutionContrat?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_106"
          v-model="dateDebutFormationModel"
          label="Date de début de formation pratique chez l’employeur"
          :required="meta.contrat?.dateDebutFormationChezEmployeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateDebutFormationChezEmployeur?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_108"
          v-model="dateFinContratModel"
          label="Date de fin du contrat ou de l’apprentissage"
          :required="meta.contrat?.dateFinContratOuPeriodeApprentissage?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dateFinContratOuPeriodeApprentissage?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          deletable
          :readonly
        />
        <WrapperInputDuree
          id="field_109"
          v-model="dureeHebdomadaireModel"
          label="Durée hebdomadaire du travail"
          :required="meta.contrat?.dureeHebdomadaire?.heure?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.dureeHebdomadaire?.heure?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :hint="HINT_DUREE"
          :placeholder="PLACEHOLDER_DUREE"
          deletable
          :maxlength="5"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_111"
          v-model="travailMachinesDangereusesModel"
          label="Travail sur machines dangereuses ou exposition à des risques particuliers"
          :required="
            meta.contrat?.travailMachinesDangereusesOuExpositionRisquesparticuliers?.$status === PropertyStatus.Required
          "
          :alertLabel="meta.contrat?.travailMachinesDangereusesOuExpositionRisquesparticuliers?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    PLACEHOLDER_DATE,
    PLACEHOLDER_DUREE,
    HINT_DATE,
    HINT_DUREE,
  } from '@/features/interface/demande/shared'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import type { DureeHebdomadaireDTO } from '@/features/api/extranet/dto/Demande/shared'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, lov, readonly } = storeToRefs(store)

  const typeContratAvenantModel = setupFieldWithKey<string>('contrat.typeContratAvenant', false) // spec en cours dépendant du tunnel de création
  const modeContractuelModel = setupFieldWithKey<string>('contrat.modeContractuel', false)
  const typeDerogationModel = setupFieldWithKey<string>('contrat.typeDerogation', false)
  const numeroContratPrecedentModel = setupFieldWithKey<string>('contrat.numeroDecaPrecedent', true) // actif selon type de contrat
  const dateConclusionModel = setupFieldWithKey<string>('contrat.dateConclusion', true)
  const dateDebutExecutionModel = setupFieldWithKey<string>('contrat.dateDebutExecutionContrat', true)
  const dateDebutFormationModel = setupFieldWithKey<string>('contrat.dateDebutFormationChezEmployeur', true)
  const dateEffetAvenantModel = setupFieldWithKey<string>('contrat.dateEffetAvenant', true)
  const dateFinContratModel = setupFieldWithKey<string>('contrat.dateFinContratOuPeriodeApprentissage', true)
  const travailMachinesDangereusesModel = setupFieldWithKey<string>(
    'contrat.travailMachinesDangereusesOuExpositionRisquesparticuliers',
    false,
  )
  const dureeHebdomadaireModel = setupFieldWithKey<DureeHebdomadaireDTO>('contrat.dureeHebdomadaire', true)
</script>
